module.exports = __webpack_public_path__ + "static/media/599.7554(32).3e57b69d.pdf";